import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
// Sections for this page
import image1 from "assets/img/ngo/image1.jpg";

const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'left' }}>
          <div style={{ paddingLeft: '10px',color: "#134c7a", margin: 0, borderLeft: "5px solid #134c7a" }}>
            <small>
              गैर सरकारी संस्था
            </small>
            <span><h3 className={classes.title} style={{ marginTop: '-10px', color: '#134c7a'}}>जानकारी</h3></span>
          </div>
              <Grid container style={{ paddingBottom: '10px',paddingTop: '10px', borderBottom: '1px solid #ddd' }} md={12}>
                <Grid xs={12} sm={4} md={3} item>
                  <div style={{
                    width: '100%', height: '200px', border: '10px solid #ddd', marginTop: '10px', marginBottom: '10px',
                    backgroundColor: 'grey', backgroundImage: "url(" + image1 + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                    />
                </Grid>
                <Grid md={9} sm={8}>
                  <h3 className={classes.description} style={{color: '#333',padding: '20px', marginTop: 0, paddingTop: '10px' }}>
                    {"संस्थाको नाम"}
                  </h3>
                  <h4 className={classes.description} style={{ margin:'15px', color: '#666', padding: '5px', paddingTop: '0px' }}>
                    परिचय
                  </h4>
                </Grid>
              </Grid>
              <Grid container style={{ paddingBottom: '10px',paddingTop: '10px', borderBottom: '1px solid #ddd' }} md={12}>
                <Grid xs={12} sm={4} md={3} item>
                  <div style={{
                    width: '100%', height: '200px', border: '10px solid #ddd', marginTop: '10px', marginBottom: '10px',
                    backgroundColor: 'grey', backgroundImage: "url(" + image1 + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                    />
                </Grid>
                <Grid md={9} sm={8}>
                  <h3 className={classes.description} style={{color: '#333',padding: '20px', marginTop: 0, paddingTop: '10px' }}>
                    {"संस्थाको नाम"}
                  </h3>
                  <h4 className={classes.description} style={{ margin:'15px', color: '#666', padding: '5px', paddingTop: '0px' }}>
                    परिचय
                  </h4>
                </Grid>
              </Grid>
              <Grid container style={{ paddingBottom: '10px',paddingTop: '10px', borderBottom: '1px solid #ddd' }} md={12}>
                <Grid xs={12} sm={4} md={3} item>
                  <div style={{
                    width: '100%', height: '200px', border: '10px solid #ddd', marginTop: '10px', marginBottom: '10px',
                    backgroundColor: 'grey', backgroundImage: "url(" + image1 + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                    />
                </Grid>
                <Grid md={9} sm={8}>
                  <h3 className={classes.description} style={{color: '#333',padding: '20px', marginTop: 0, paddingTop: '10px' }}>
                    {"संस्थाको नाम"}
                  </h3>
                  <h4 className={classes.description} style={{ margin:'15px', color: '#666', padding: '5px', paddingTop: '0px' }}>
                    परिचय
                  </h4>
                </Grid>
              </Grid>
              <Grid container style={{ paddingBottom: '10px',paddingTop: '10px', borderBottom: '1px solid #ddd' }} md={12}>
                <Grid xs={12} sm={4} md={3} item>
                  <div style={{
                    width: '100%', height: '200px', border: '10px solid #ddd', marginTop: '10px', marginBottom: '10px',
                    backgroundColor: 'grey', backgroundImage: "url(" + image1 + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                    />
                </Grid>
                <Grid md={9} sm={8}>
                  <h3 className={classes.description} style={{color: '#333',padding: '20px', marginTop: 0, paddingTop: '10px' }}>
                    {"संस्थाको नाम"}
                  </h3>
                  <h4 className={classes.description} style={{ margin:'15px', color: '#666', padding: '5px', paddingTop: '0px' }}>
                    परिचय
                  </h4>
                </Grid>
              </Grid>
              <Grid container style={{ paddingBottom: '10px',paddingTop: '10px', borderBottom: '1px solid #ddd' }} md={12}>
                <Grid xs={12} sm={4} md={3} item>
                  <div style={{
                    width: '100%', height: '200px', border: '10px solid #ddd', marginTop: '10px', marginBottom: '10px',
                    backgroundColor: 'grey', backgroundImage: "url(" + image1 + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                    />
                </Grid>
                <Grid md={9} sm={8}>
                  <h3 className={classes.description} style={{color: '#333',padding: '20px', marginTop: 0, paddingTop: '10px' }}>
                    {"संस्थाको नाम"}
                  </h3>
                  <h4 className={classes.description} style={{ margin:'15px', color: '#666', padding: '5px', paddingTop: '0px' }}>
                    परिचय
                  </h4>
                </Grid>
              </Grid>
              <Grid container style={{ paddingBottom: '10px',paddingTop: '10px', borderBottom: '1px solid #ddd' }} md={12}>
                <Grid xs={12} sm={4} md={3} item>
                  <div style={{
                    width: '100%', height: '200px', border: '10px solid #ddd', marginTop: '10px', marginBottom: '10px',
                    backgroundColor: 'grey', backgroundImage: "url(" + image1 + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                    />
                </Grid>
                <Grid md={9} sm={8}>
                  <h3 className={classes.description} style={{color: '#333',padding: '20px', marginTop: 0, paddingTop: '10px' }}>
                    {"संस्थाको नाम"}
                  </h3>
                  <h4 className={classes.description} style={{ margin:'15px', color: '#666', padding: '5px', paddingTop: '0px' }}>
                    परिचय
                  </h4>
                </Grid>
              </Grid>
        </GridItem>
      </GridContainer>
    </div>
  );
}
